import moment from 'moment';
import 'moment-timezone';

export const TimezoneOffsets = moment.tz.names().map(tzName => {
    const rawOffset = moment.tz(tzName).format('Z');
    const sign = rawOffset.charAt(0);
    const cleanOffset = rawOffset.substr(1);
    const offsetArray = cleanOffset.split(':');
    const minutes = Number(offsetArray[0] * 60) + Number(offsetArray[1]);

    return {
        name:   tzName,
        offSet: sign + minutes
    };
});

export const UserTimezone = moment.tz.guess();

export const UserTimezoneOffset =
    TimezoneOffsets.find(({ name }) => name === UserTimezone);

export const getTimeZoneAbbr = (time, zone) => {
    return moment.tz.zone(zone).abbr(moment(time));
};
